import { chain } from '@lyearn/core/utils/immutable';

interface ReorderItemsParams<T> {
  fromIndex: number;
  toIndex: number;
  items: T[];
}

export function reorderItems<T>(params: ReorderItemsParams<T>): T[] {
  const { fromIndex, toIndex, items } = params;
  const itemToReorder = items[fromIndex];

  if (itemToReorder) {
    return chain(items).splice(fromIndex, 1).splice(toIndex, 0, itemToReorder).value();
  }

  return items;
}
